module.exports = __webpack_public_path__ + "static/media/201-Monolog_ID_1.3950f6d5.mp3";